import graphql__304d4ded2fe27501b254 from "./__generated__/ContributionCardThemes_contribution.graphql.js";
import graphql__a01141817cd38f421f23 from "./__generated__/ContributionCardThemes_theme.graphql.js";import { graphql, useFragment } from "react-relay";
import classNames from "classnames";

import { themePathFor } from "../../Utils/themePathFor";
import Icon from "../../Utils/Icon";

const ContributionCardThemes = props => {
  const contribution = useFragment(
    ContributionCardThemes_contribution,
    props.contribution
  );

  const providedTheme = useFragment(ContributionCardThemes_theme, props.theme);

  const theme = providedTheme || contribution.theme;
  const { rootTheme, subTheme } = themePathFor(theme);

  if (!rootTheme || !subTheme) return null;

  const iconClass = classNames(["align-middle", subTheme?.iconClass]);

  const { primaryColor, primaryContrastColor } = subTheme;

  return (
    <div className="dataviz-box-top-label">
      <div
        style={{
          backgroundColor: primaryColor,
          color: primaryContrastColor
        }}
        className="theme"
      >
        {rootTheme.name}
      </div>

      <div
        style={{
          backgroundColor: primaryColor,
          color: primaryContrastColor
        }}
        className="icon"
      >
        <Icon className={iconClass} />
        <span className="sr-only">{subTheme?.name}</span>
      </div>
    </div>
  );
};

const ContributionCardThemes_contribution = graphql__304d4ded2fe27501b254;

const ContributionCardThemes_theme = graphql__a01141817cd38f421f23;

export default ContributionCardThemes;
